var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgGameStop = function SvgGameStop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3104_80271)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21 0H11C4.92487 0 0 4.92487 0 11V21C0 27.0751 4.92487 32 11 32H21C27.0751 32 32 27.0751 32 21V11C32 4.92487 27.0751 0 21 0Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.86889 12.6868V21.3057C9.86889 21.9352 10.347 22.4111 10.968 22.4111H21.036C21.657 22.4111 22.1351 21.9352 22.1351 21.3057V14.077H23.724V21.3057C23.724 22.8077 22.5395 24 21.036 24H10.968C9.46452 24 8.28003 22.8077 8.28003 21.3057V12.6868H9.86889Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.28003 10.6943C8.28003 9.19227 9.46452 8 10.968 8H21.3686V11.151H21.544C22.7704 11.151 23.724 12.1116 23.724 13.3356V14.4013C23.724 15.6253 22.7704 16.5859 21.544 16.5859H10.968C9.46452 16.5859 8.28003 15.3936 8.28003 13.8916V10.6943ZM19.7797 11.151V9.58886H10.968C10.347 9.58886 9.86889 10.0648 9.86889 10.6943V13.8916C9.86889 14.5212 10.347 14.9971 10.968 14.9971H15.2076V11.151H19.7797ZM16.7964 14.9971H21.544C21.8879 14.9971 22.1351 14.7528 22.1351 14.4013V13.3356C22.1351 12.9841 21.8879 12.7399 21.544 12.7399H16.7964V14.9971Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.964 12.8807H17.0825V14.9992H14.964V12.8807Z",
    fill: "url(#paint0_linear_3104_80271)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2349 9.30048H21.5441V11.154H19.2349V9.30048Z",
    fill: "url(#paint1_linear_3104_80271)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3104_80271",
    x1: 16.0232,
    y1: 16.4115,
    x2: 16.0232,
    y2: 13.5869,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3104_80271",
    x1: 20.3894,
    y1: 12.3897,
    x2: 20.3894,
    y2: 9.91831,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3104_80271"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
};

export { SvgGameStop as ReactComponent };
export default __webpack_public_path__ + "ad90405855743b90127591a173cd2ef1.svg";